export const LEGAL_CGU_URL = "https://gemster.io/cgu/";
export const LEGAL_PRIVACY_URL = "https://gemster.io/privacy/";
